<template>
  <div class="footer">
    <div class="footer-nav">
      <Navigation :invert="true"></Navigation>
    </div>
    <div class="footer-copyright">
      Copyright © 2025 Regtime, Inc. All rights reserved.
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation";

export default {
  name: "Footer",
  components: {
    Navigation,
  },
  methods: {
    scrollTo(query){
      const el = document.getElementById(query);
      if (el) {
        el.scrollIntoView({behavior: 'smooth'});
      }
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: #FFFFFF;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}

.footer-nav {
  /* position: relative;
  background-color: transparent;
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center; */
}

.footer-copyright {
  display: flex;
  height: 40px;
  padding: 10px 60px 10px 60px;
  justify-content: center;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
  background: #F4F6FF;

  color: var(--Font-navy, #0A1250);
  font-family: "Open Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  /* 158.333% */
}
@media screen and (max-width: 768px) {
  .footer {
    /* border-top: 1px solid #E6E8FF; */
    width: 100%;
    margin: 0 auto;
    padding: 24px ;
    overflow: hidden;
  }
}
/* @media screen and (max-width: 420px) {
  .footer-copyright {
    margin-top: 0;
    height: 40px;
    line-height: 40px;

  }
} */
</style>
